import {
    Box,
    chakra,
    Container,
    Link,
    Stack,
    Text,
    useColorModeValue,
    VisuallyHidden,
} from '@chakra-ui/react';

import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import AllyLogo from '../../assets/logos/ally.svg'

import './footer.scss';

const SocialButton = ({
    children,
    label,
    href,
}) => {
    return (
    <chakra.button
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        w={8}
        h={8}
        cursor={'pointer'}
        display={'inline-flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'background 0.3s ease'}
        _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
        }}>
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
    </chakra.button>
    );
};

const CurrentYear = () => {
    const d = new Date();
    return d.getFullYear();
}

const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};

//Best video ever
const socialLink = 'https://www.youtube.com/watch?v=QDia3e12czc&ab_channel=Everythingistroll';
  
export default function Footer() {
    return (
      <Box
        bg={useColorModeValue('gray.50', 'gray.900')}
        color={useColorModeValue('gray.700', 'gray.200')}
        className='footer'
        >
            <Container
                as={Stack}
                maxW={'6xl'}
                py={4}
                direction={{ base: 'column', md: 'row' }}
                spacing={4}
                justify={{ base: 'center', md: 'space-between' }}
                align={{ base: 'center', md: 'center' }}
            >
            <img
                onClick={goToTop}
                src={AllyLogo}
                alt="ally logo"
                className='logo'
            />
            <Text fontSize='xs' >© {CurrentYear()} ally™. All rights reserved</Text>
            <Stack direction={'row'} spacing={6}>
                <Link
                    href={socialLink}
                    isExternal
                    _hover={{
                        color: 'brand.main',
                    }}
                >
                    <SocialButton label={'Twitter'}>
                        <FaTwitter />
                    </SocialButton>
                </Link>
                <Link
                    href={socialLink}
                    isExternal
                    _hover={{
                        color: 'brand.main',
                    }}
                >
                    <SocialButton label={'YouTube'}>
                        <FaYoutube />
                    </SocialButton>
                </Link>
                <Link
                    href={socialLink}
                    isExternal
                    _hover={{
                        color: 'brand.main',
                    }}
                >
                    <SocialButton label={'Instagram'}>
                        <FaInstagram />
                    </SocialButton>
                </Link>
            </Stack>
            </Container>
        </Box>
    );
}